export default {"src":"/_next/static/media/phone.d978f14f.svg","height":14,"width":12,"blurWidth":0,"blurHeight":0};